function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M28.015 25.571H3.986L7.091 6.429h18.338l.017.124zm-23.693-.286h23.366l-2.51-18.57H7.333z" /><path d="M6.899 8.353h18.664v.286H6.899zm.764 17.061L8.8 14.342l.285.029-1.138 11.071zm15.063-11.04l.284-.034 1.335 11.071-.284.034zM12.239 25.421l.566-11.071.286.015-.566 11.072zm6.862-11.057l.286-.015.572 11.071-.286.015zm-3.246 11.063l.085-9.714.286.003-.085 9.714z" /></svg>;
});